import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material'
import { AggregationPeriod } from '@src/types/MerchantStatistic'
import { useTranslation } from 'react-i18next'

interface LoanMetricsAggregationTogglesProps {
  aggregation: AggregationPeriod
  onAggregationChange: (aggregation: AggregationPeriod) => void
}

export const LoanMetricsAggregationToggles = ({
  aggregation,
  onAggregationChange,
}: LoanMetricsAggregationTogglesProps) => {
  const { t } = useTranslation()

  const handleChange = (_: React.MouseEvent<HTMLElement>, newAgg: AggregationPeriod | null) => {
    if (newAgg) onAggregationChange(newAgg)
  }

  return (
    <Box sx={{ mb: 3 }}>
      <ToggleButtonGroup value={aggregation} exclusive onChange={handleChange} size="small">
        {Object.values(AggregationPeriod).map((period) => (
          <ToggleButton key={period} value={period}>
            {t(`merchantStatistics.merchantLoanActivity.${period}` as const)}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  )
}
